/** The PCS Internal wordmark. */
export function Brand() {
  return (
    <span className="brand">
      <span className="brand-mark" aria-hidden="true"><i></i><i></i><i></i></span>
      <span className="brand-name">PCS<small>Internal</small></span>
    </span>
  );
}
